/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetAllDevisionsEntity } from '../models/GetAllDevisionsEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProvincesService {
  /**
   * @returns GetAllDevisionsEntity
   * @throws ApiError
   */
  public static provincesControllerGetAllDevisions(): CancelablePromise<GetAllDevisionsEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/provinces/all-devisions',
    });
  }
}
